<template>
	<div class="join_team_success">
		<img class="top_img" src="../../assets/img/app_download.png" />
		<div class="phone">
			<img src="../../assets/img/logo.png" />
			<div class="text-name">医阵营</div>
			<div class="download" @click="download">下载APP</div>
		</div>
	</div>
</template>
<script>
export default {
    name: 'joinTeamSuccess',
    data () {
        return {}
    },
    methods: {
        download () {
            let phoneType = this.$utils.phoneType()
            if (phoneType.isiOS) {
                //https://apps.apple.com/cn/app/%E5%8C%BB%E5%8A%A0%E5%8C%BB%E7%94%9F%E7%AB%AF/id1484041430   
                window.location.href = "https://apps.apple.com/cn/app/id1484041430"
            }
            if (phoneType.isAndroid) {
                // https://download.mwcare.cn/android/med_v2.0.apk
                window.location.href = "https://3g.lenovomm.com/redsea/com.mediwelcome.hospital?rank_code=search_2_%E9%BA%A6%E8%BF%AA%E5%8C%BB%E5%8A%A0&num=1"
            }
        }
    }
}
</script>
<style lang="less" scoped>
.join_team_success {
	background: linear-gradient(180deg, #6f56d6 0%, rgba(255, 255, 255, 0) 100%);
	min-height: 100vh;
	overflow: hidden;
}
.top_img {
	width: 750px;
	position: fixed;
	top: 0;
}
.phone {
	background-image: url('../../assets/img/phone.png');
	background-size: 100% auto;
	width: 601px;
	height: 1031px;
	margin: 360px auto 0 auto;
	text-align: center;
	overflow: hidden;
	img {
		width: 200px;
		height: 200px;
		margin-top: 197px;
		border-radius: 48px;
	}
	.text-name {
		font-size: 60px;
		color: #1f2329;
		margin-top: 31px;
	}
}
.download {
	width: 332px;
	text-align: center;
	height: 92px;
	line-height: 92px;
	color: #ffffff;
	border-radius: 16px;
	background-color: #6f56d6;
	font-size: 32px;
	margin: 96px auto 0 auto;
}
</style>